import { types } from "../action-types";

const initialState = {
  loading: false,
  gigs: [],
  error: false,
};

const getRecentgigReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_JOB_LISTING_RECENT_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_JOB_LISTING_RECENT_SUCESS:
      return {
        ...state,
        loading: false,
        gigs: action.payload,
        error: false,
      };
    case types.GET_JOB_LISTING_RECENT_FAILURE:
      return {
        ...state,
        loading: false,
        gigs: [],
        error: true,
      };
    default:
      return state;
  }
};

export default getRecentgigReducer;
